import * as Bowser from 'bowser';

let bowserInfoCache: Bowser.Parser.ParsedResult | undefined;
let isIeCache: boolean | undefined;
let isEdgeHTMLCache: boolean | undefined;

export function getBowserInformation(): Bowser.Parser.ParsedResult {
  if (bowserInfoCache === undefined) {
    bowserInfoCache = Bowser.parse(window.navigator.userAgent);
  }
  return bowserInfoCache;
}

export function detectBrowser() {
  const $html = $('html');
  const browserInfo = getBowserInformation().browser;
  const os = getBowserInformation().os;

  if (browserInfo && browserInfo.name && browserInfo.version) {
    const browserName = makeNiceString(browserInfo.name);
    $html.addClass(browserName);
    $html.addClass(browserName + '--' + makeNiceString(browserInfo.version));
  }

  if (os && os.name && os.versionName) {
    const osName = makeNiceString(os.name);
    $html.addClass(osName);
    $html.addClass(osName + '--' + makeNiceString(os.versionName));
  }
}

export function isIE() {
  if (isIeCache === undefined) {
    isIeCache = makeNiceString(getBowserInformation().browser.name || '') === 'internet-explorer';
  }
  return isIeCache;
}

export function isEdgeWithEdgeHTMLEngine() {
  if (isEdgeHTMLCache === undefined) {
    isEdgeHTMLCache = makeNiceString(getBowserInformation().browser.name || '') === 'microsoft-edge'
      && getBowserInformation().engine.name === 'EdgeHTML';
  }
  return isEdgeHTMLCache;
}

function makeNiceString(input: string): string {
  const output = input.toLowerCase().replace(' ', '-');
  if (output.indexOf('.') < 0) {
    return output;
  }
  return output.substr(0, output.indexOf('.'));
}
